import { Button, createSlotRecipeContext, type HTMLChakraProps } from '@chakra-ui/react'
import { LuChevronLeft, LuChevronRight } from 'react-icons/lu'

import { periodPagerRecipe } from '@/theme/recipes/period-pager.recipe'

const { withProvider, withContext } = createSlotRecipeContext({ recipe: periodPagerRecipe })

const Root = withProvider<HTMLDivElement, HTMLChakraProps<'div'>>('div', 'root')
const Label = withContext<HTMLSpanElement, HTMLChakraProps<'span'>>('span', 'label')

type PeriodPagerProps = {
  label: string | number
  previousLabel: string
  nextLabel: string
  onPrevious: () => void
  onNext: () => void
  previousDisabled?: boolean
  nextDisabled?: boolean
  testIdPrefix?: string
}

export function PeriodPager({
  label,
  previousLabel,
  nextLabel,
  onPrevious,
  onNext,
  previousDisabled,
  nextDisabled,
  testIdPrefix,
}: PeriodPagerProps) {
  return (
    <Root data-testid={testIdPrefix ? `${testIdPrefix}-selector` : undefined}>
      <Button
        data-testid={testIdPrefix ? `${testIdPrefix}-prev` : undefined}
        aria-label={previousLabel}
        variant="plain"
        onClick={onPrevious}
        disabled={previousDisabled}
      >
        <LuChevronLeft />
      </Button>
      <Label data-testid={testIdPrefix ? `${testIdPrefix}-value` : undefined}>{label}</Label>
      <Button
        data-testid={testIdPrefix ? `${testIdPrefix}-next` : undefined}
        aria-label={nextLabel}
        variant="plain"
        onClick={onNext}
        disabled={nextDisabled}
      >
        <LuChevronRight />
      </Button>
    </Root>
  )
}
